import { GenericCrudPage } from '@/components/GenericCrudPage';
import { scoringDisputesConfig } from '@/pages/configs';

export default function ScoringDisputesPage() {
  return <GenericCrudPage config={scoringDisputesConfig} />;
}
